// src/store/tokenStore.js
let state = {
    accessToken: null,
    refreshToken: null
};

const listeners = new Set();


export const tokenStore = {
    get() {
        return state;
    },
    getAccessToken() {
        return state.accessToken;
    },
    getRefreshToken() {
        return state.refreshToken;
    },
    set(tokens) {
        state = tokens
            ? { accessToken: tokens.accessToken ?? null, refreshToken: tokens.refreshToken ?? null }
            : { accessToken: null, refreshToken: null };

        // 구독자들에게 알림
        listeners.forEach((fn) => {
            try { fn(state); } catch {}
        });
    },
    clear() {
        this.set(null);
    },
    subscribe(fn) {
        listeners.add(fn);
        // 구독 해제 함수 리턴
        return () => listeners.delete(fn);
    },
};